module.exports = __webpack_public_path__ + "img/no2.5858d4c2.jpg";